import { ItemCardContainer } from "@/components/ItemCard";
import { type NormalizedDrawing } from "@repo/api";
import { Skeleton } from "@repo/skapa";

import { useSearchDesignById } from "../hooks/search";
import { DrawingCard } from "./DrawingCard";

export const DrawingItem = ({
  editable,
  drawingInfo,
  onDisassociate,
  drawingInLoading,
}: {
  editable: boolean;
  drawingInfo: NormalizedDrawing;
  onDisassociate?: (drawingId: string) => void;
  drawingInLoading?: string;
}) => {
  const { data, isValidating } = useSearchDesignById(
    drawingInfo.isVPCDrawing ? drawingInfo.id : undefined
  );

  if (isValidating || drawingInLoading === drawingInfo.id) {
    return (
      <ItemCardContainer>
        <Skeleton data-testid="loading-design" height="115px" width="100%" />
      </ItemCardContainer>
    );
  }

  return (
    <DrawingCard
      editable={editable ?? false}
      drawingInfo={drawingInfo}
      onDisassociate={onDisassociate}
      vpcDrawing={data}
      isVpDrawingValidating={isValidating}
    />
  );
};
